<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader title="MD 2 - Investment Experience and Knowledge" :icon="UsersIcon"></WizardHeader>
            <ManagerListItem
                class="border-y border-gray-200 px-2 py-2"
                :manager="state.legalProfile.managers[0]"></ManagerListItem>
            <div class="px-4 pb-6 sm:px-6">
                <BaseInputRadio
                    v-model="isAuthorized"
                    name="fatca_declaration.us_citizen_or_resident"
                    :options="yesNoOptions"
                    label="Are you authorized to share the personal experience and knowledge of authorized represantative 2?" />
                <InlineAlert
                    v-if="isAuthorized === 'no'"
                    class="mt-4"
                    title="Please contact the authorized representative 2"
                    description=" If you do not have the MD 2’s approval to complete this section on her/his behalf, please contact her/him and return to this form once it is received. If you are experiencing any issues, please contact Venionaire at platform@superangels.club."
                    type="Error">
                </InlineAlert>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary :disabled="isAuthorized !== 'yes'" size="lg" @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                If you do not have the MD 2’s approval to complete this section on her/his behalf, please contact
                her/him and return to this form once it is received. If you are experiencing any issues, please contact
                Venionaire at platform@superangels.club.
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { inject, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import ManagerListItem from '../../../account/legal/managers/ManagerListItem.vue'
import BaseInputRadio from '../../../base/BaseInputRadio.vue'
import { yesNoOptions } from '../../../../data'
import InlineAlert from '../../../base/InlineAlert.vue'

const isAuthorized = ref(null)

const state = useLegalAccountDataState()
const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')

async function submit() {
    navigateToNextTab()
}
</script>

<style scoped></style>
